import type { AcaraIconName } from './iconCatalog'

type AcaraIconSize = 16 | 20 | 24 | 32

type AcaraIconProps = {
  name: AcaraIconName
  size?: AcaraIconSize
  label?: string
  className?: string
}

export function AcaraIcon({ name, size = 24, label, className }: AcaraIconProps) {
  const strokeWidth = size === 16 ? 2.15 : size === 20 ? 2.05 : 2
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden={label ? undefined : true}
      aria-label={label}
      role={label ? 'img' : undefined}
      focusable="false"
    >
      {label ? <title>{label}</title> : null}
      <use href={`/assets/acara/icons/acara-icons.svg#acara-icon-${name}`} />
    </svg>
  )
}

